import style from "./AppointmentForm.module.css";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {data} from '../../../../../evn/evn'
import { Button, Tooltip } from "@mui/material";
import { ToastContainer, toast } from 'react-toastify';


const AppointmentForm = ({ onClose }) => {
  const [appointmentDateError, setAppointmentDateError] = useState("");
  const [caseTitles, setCaseTitles] = useState([]); // Store fetched case titles
  const [caseTypeMap, setCaseTypeMap] = useState({}); // Store case types based on titles
  const [casetitle, setCaseTitle] = useState("");
  const [casetype, setCaseType] = useState("");
  const [contactperson, setContactPerson] = useState("");
  const [location, setLocation] = useState("");
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [email, setEmail] = useState("");
  const [title, setTitle] = useState("");
  const [titleErrorAppointment, setAppointmentError] = useState("");
  const [desc, setDesc] = useState("");
  const navigate = useNavigate();
  const [clientNames, setClientNames] = useState([]); // State to store client first names
  const ip = data.evn
  // const handleClose = () => {
  //   setOpenEvent(false);
  //   setOpenSlot(false);
  // };
  const handleStartTime = (newStartTime) => {
    setStart(newStartTime);
  };

  // const navigate = useNavigate();
  const HandleCancel = () => {
    onClose();
  };

  const handleEndTime = (newEndTime) => {
    setEnd(newEndTime);
  };
  useEffect(() => {
    const fetchCaseTitlesAndTypes = async () => {
      try {
        const response = await axios.get(`${ip}/caseform`, {
          headers: { "x-auth-token": localStorage.getItem("token") },
        });
        const data = response.data; // Assuming the API response is an array of objects with "title" and "caseType" properties

        // Process the data and update the state
        const titles = data.map((item) => item.title);
        const typeMap = {};
        data.forEach((item) => {
          typeMap[item.title] = item.type_name;
        });

        setCaseTitles(titles);
        setCaseTypeMap(typeMap);
      } catch (error) {
        toast.error("Error fetching case titles and types:", error);
      }
    };

    const fetchClientNames = async () => {
      try {
        const response = await axios.get(`${ip}/clientform`, {
          headers: {
            'x-auth-token': localStorage.getItem('token'), // Get the token from localStorage or your authentication mechanism
          },
        });

        // Extract the first names from the response data
        const firstNamesArray = response.data.map((client) => client.firstName);
        setClientNames(firstNamesArray);
      } catch (error) {
        toast.error(error);
      }
    };

    fetchClientNames();
    fetchCaseTitlesAndTypes(); // Call the new function to fetch case titles and types

  }, []);
  
  const setNewAppointment = async () => {

    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    const selectedAppointmentDate = new Date(desc);

    if (selectedAppointmentDate < currentDate) {
      setAppointmentDateError("Appointment date must be today or in the future");
      return; // Stop function execution if validation fails
    } else {
      setAppointmentDateError(""); // Clear error message if validation passes
    }
    try {
      const formData = {
        title,
        caseTitle: casetitle,
        caseType: caseTypeMap[casetitle] || "",
        appointmentDate: desc,
        contactPerson: contactperson, // Use the correct variable name 'contactperson'
        location,
        startTime: start,
        endTime: end,
        email,
      };

      // Send a POST request to your backend API
      const response = await axios.post(
        `${ip}/appointments`,
        formData,
        {
          headers: { "x-auth-token": localStorage.getItem("token") },
        }
      );

      // Handle the response from the server
      if (response.status === 200) {
        // Appointment was successfully added
        alert("Appointment added successfully");
        // You can perform any additional actions or show a success message here.
        navigate(0);
      } else {
        // Handle errors here
        toast.error("Error adding appointment:", response.data.error);
        // You can show an error message to the user if needed.
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        setAppointmentError("An appointment with this title already exists. Please use a different title.");
      } else {
        toast.error("Error saving task:", error);
      }
      // Handle any other errors here
    }
  };

  return (
    <div>
      <div className={style.AppointmentVisibleForm}>
        <div className={style.formRow}>
        <div className={style.formGroup}>

          <label className={style.AppointmentFormTitle}>Title</label>
          <input
            className={style.TasksVisibleInput}
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          </div>
          <div className={style.formGroup}>

          <label className={style.TasksVisibleTitle}>Case Title</label>
          <select
            className={style.TasksVisibleInput}
            value={casetitle}
            onChange={(e) => setCaseTitle(e.target.value)}
          >
            <option value="" disabled>
              Select Case Title
            </option>
            {caseTitles.map((title) => (
              <option key={title} value={title}>
                {title}
              </option>
            ))}
          </select>
          </div>
        </div>
        {titleErrorAppointment && <span className={style.errorMsg}>{titleErrorAppointment}</span>} {/* Display the error message */}

        <div className={style.formRow}>
        <div className={style.formGroup}>

          <label className={style.AppointmentFormTitle}>Case Type</label>
          <input
            className={style.TasksVisibleInput}
            type="text"
            value={caseTypeMap[casetitle] || ""}
            readOnly
            placeholder="Case Type"
          />
          </div>

          <div className={style.formGroup}>
          <label className={style.HearingVisibleFormTitle}>
            Appointment Date
          </label>
          <input
            className={style.HearingVisibleFormDate}
            type="date"
            value={desc}
            onChange={(e) => setDesc(e.target.value)}
          />
           {appointmentDateError && <span className={style.errorMsg}>{appointmentDateError}</span>} {/* Display the error message */}
          </div>
        </div>
        <div className={style.formRow}>
        <div className={style.formGroup}>

          <label className={style.AppointmentFormTitle}>Contact Person</label>
          <select
            className={style.TasksVisibleInput}
            value={contactperson}
            onChange={(e) => setContactPerson(e.target.value)}
          >
            
            <option value=""  disabled selected>Select contact person</option>
                    {clientNames.map((firstName) => (
                      <option key={firstName} value={firstName}>
                        {firstName}
                      </option>
                    ))}
          </select>
          </div>
  
          <div className={style.formGroup}>
          <label className={style.AppointmentFormTitle}>Location</label>
          <input
            className={style.HearingVisibleFormInput}
            type="text"
            value={location}
            placeholder="Location"
            onChange={(e) => setLocation(e.target.value)}
          />
          </div>
        </div>

        <div className={style.formRow}>
          <div className={style.formGroup}>
            <label className={style.AppointmentFormTitle}>Start Time</label>
            <input
              className={style.TasksVisibleInputTime}
              type="time"
              value={start || ""}
              onChange={(e) => {
                const newStartTime = e.target.value;
                handleStartTime(newStartTime);
              }}
            />
          </div>

          <div className={style.formGroup}>
            <label className={style.AppointmentFormTitle}>End Time</label>
            <input
              className={style.TasksVisibleInputTime}
              type="time"
              value={end || ""}
              onChange={(e) => {
                const newEndTime = e.target.value;
                handleEndTime(newEndTime);
              }}
            />
          </div>

          <div className={style.formGroup}>
          <label className={style.HearingVisibleFormTitle}>Email</label>
          <input
            className={style.HearingVisibleFormInput}
            type="email"
            value={email}
            placeholder="Email"
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        </div>
      <div className={style.BtnContainerAppoint}>
      <Tooltip title="Submit Form">
        <button className={style.submitButton} onClick={setNewAppointment}>
          Submit
        </button>
</Tooltip>
      <Tooltip title="Cancel Form">
        <button  onClick={HandleCancel} className={style.CancelButton}>
          Cancel
        </button>
</Tooltip>
      </div>
      </div>
    <ToastContainer/>
    </div>
  );
};

export default AppointmentForm;
